// @flow

import Notifications from '../../constants/Notifications';
import CarouselSliderItemWrapper from './CarouselSliderItemWrapper';
import { uppercaseFirst } from '../../classes/Helpers';

type CalculationProperties = ['top' | 'left', 'height' | 'width'];

export default class CarouselSliderThumbnails extends CarouselSliderItemWrapper {
  activeClass: string = 'carousel-slider__item--active';
  calculationProperties: CalculationProperties;

  /**
   * Instantiate the component
   */
  bind(pEl: HTMLElement) {
    super.bind(pEl);
    this.addListener(Notifications.RESIZE, this.reposition.bind(this));
    this.addListener(Notifications.CAROUSEL_CHANGE_INDEX, this.reposition.bind(this));
    this.addListener(Notifications.CAROUSEL_UPDATE_NAVIGATION, this.reposition.bind(this));
  }

  /**
   * @inheritDoc
   */
  reposition({ index }: { index: number }): void {
    if (!this.calculationProperties[0] || !this.calculationProperties[1]) {
      throw new Error('Calculation properties are not defined');
    }

    if (index !== undefined) {
      this.index = index;
    }

    const thumbnail = this.items[this.index] || this.items[0];
    const distanceProperty = `offset${uppercaseFirst(this.calculationProperties[0])}`;
    const sizeProperty = `offset${uppercaseFirst(this.calculationProperties[1])}`;

    const position: number = thumbnail[distanceProperty] + (thumbnail[sizeProperty] / 2);
    const center: number = this.el.parentElement[sizeProperty] / 2;

    const size = this.el[sizeProperty];
    const parentSize = this.el.parentElement[sizeProperty];
    const diff = size - parentSize;

    if (position < center) {
      this.el.style[this.calculationProperties[0]] = '0';
    } else if ((position - center) > diff) {
      this.el.style[this.calculationProperties[0]] = '-' + (diff) + 'px';
    } else {
      this.el.style[this.calculationProperties[0]] = '-' + (position - center) + 'px';
    }

    this.items.forEach((element: HTMLLIElement) => element.firstElementChild.classList.remove(this.activeClass));
    thumbnail.firstElementChild.classList.add(this.activeClass);
  }

  /**
   * @inheritDoc
   */
  handleUpdate({ product: { id } }: { product: { id: number } }): void {
    this.rebuildComponent(id);
    this.renewIndexes();
  }

  /**
   * Renew the indexes on the items
   */
  renewIndexes(): void {
    this.items.forEach((element: HTMLLIElement, index: number) => {
      element.firstElementChild.dataset.index = index;
    });
  }
}
